import React,{useEffect,useState} from 'react'
import { Grid, Theme,Typography,useMediaQuery,useTheme} from '@mui/material';
import { createStyles, makeStyles } from "@mui/styles";
import useNextSchedule from 'hooks/useNextSchedule';
import { useStore } from 'store/StoreProvider';
import { NoSchedule } from 'assets';
import useFilteredProviders from 'hooks/useFiltereProviders';
import { useSession } from 'hooks/SessionProvider';
import moment from 'moment';
import { noSchedule } from 'assets/icons/base64Icons';
import useGetParsedDateTime from 'hooks/useGetParsedDateTime';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      timeSlotMain: {
        border: "1px solid #d6d6d6",
        borderRadius: "10px",
        minHeight: "35px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.up('md')]: {
          marginBottom: "8px"
        },
        paddingLeft:"10px",
        paddingRight:"10px",
        cursor: "pointer", 
        '&:hover': {
          backgroundColor: "#3D5A80", // Change background color on hover
          '& $timeFonts': {
            color: "#fff", // Change text color on hover for timeFonts class
          },
        },
      },
      timeFonts: {
        color: "#3D5A80"
      },
      timeSlotsMobile:{
          [theme.breakpoints.down('md')]:{
              display:"flex",
              gap:"5px"
          }
      },
      nextAvailableSchedule:{
        [theme.breakpoints.up('md')]:{
          minHeight:"150px",
        }, 
        [theme.breakpoints.down('md')]:{
          paddingTop:"37px",
          paddingBottom:"25px",
        },
        width:"100%",
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
      },
      notAvailableSchedule:{
        minHeight:"150px",
        width:"100%",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        backgroundColor:"#f6f6f6",
        borderRadius:"5px",
        marginBottom:"30px"
      },
      notAvailableBody:{
        [theme.breakpoints.down('md')]:{
          marginTop:"20px",
          marginRight:"10px"
        },
        width:"100%"
      },
    })
  );
  interface props{
    schedules?:any;
    doctorId:number;
    duration:number;
  }

const NextAvailableSchedule:React.FC<props>=({schedules,doctorId,duration})=> {
  const classes = useStyles();
  const store = useStore();
  const data = store.getData();
  const {startedDate,setStartedDate}=useSession();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const parsedDate = useGetParsedDateTime(startedDate);
  const[daysToNext, setDaysToNext] = useState(() => {
    if (isSmallScreen) return 0;
    return data?.DaysToShow;
  });
  
  const aboveDate = parsedDate ? parsedDate.clone().add(daysToNext, 'days') : null;
  const nextSchedule = useNextSchedule(schedules, doctorId, aboveDate,data?.start_datetime,data?.hours_to_skip_schedules,duration);
  const monthName = nextSchedule ? nextSchedule.format('MMM') : "";
  const dayName = nextSchedule ? nextSchedule.format('dddd') : ""; 
  const  DRDetails =useFilteredProviders(data?.Providers,doctorId)
  const [loading, setLoading] = useState(true);
  useEffect(() => {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 30);
      return () => clearTimeout(timer);
  }, [nextSchedule]);

  const cleanPhoneNumber = (phone:string) => {
    return phone.replace(/\D/g, '');
  };
  
  if(nextSchedule && !loading)
    {
      return (
        <Grid item className={classes.nextAvailableSchedule}>
          <Grid className={classes.timeSlotMain} onClick={()=>{setStartedDate(moment.parseZone(nextSchedule))}}>
            <Typography variant='body2' className={classes.timeFonts}>{`Next available:`}
              <strong>{` ${dayName} ${monthName} ${nextSchedule?.date()}`}</strong>
            </Typography>
          </Grid>
        </Grid>
      );
    }
    else if(!loading && !nextSchedule)
    {
        
      return (
       <Grid className={classes.notAvailableBody}>
         <Grid className={classes.notAvailableSchedule}>
            <Grid>
                <Grid sx={{display:"flex",justifyContent:"center",marginBottom:"10px"}}>
                    <img src={noSchedule} alt="" height={60} />
                </Grid>
                <Grid sx={{textAlign:"center",paddingLeft:"15px",paddingRight:"15px"}}>
                <Typography sx={{ fontSize: "13px" }}>
                    {`Call us at `}
                    <a href={`tel:${cleanPhoneNumber(data?.BusinessDetails?.primary_phone)}`}>{data?.BusinessDetails?.primary_phone}</a>
                    {` to check for availabilities.`}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
       </Grid>
      );
    }
    else  return null;
}

export default NextAvailableSchedule
